module.exports = __webpack_public_path__ + "img/playground.15c71e64.jpg";